import {
  DownOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlusOutlined,
} from '@ant-design/icons';

import { Avatar, Button, Dropdown, Layout, Menu, Modal, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import collapsed_logo from '../../Images/logo-icon.svg';
import Logo from '../../Images/logo.svg';
import profilePic from '../../Images/user.svg';
import { logoutAndReset } from '../../slices/auth';
const { Sider } = Layout;

const { confirm } = Modal;

const parentKeys = {
  '/die-group-list': '555',
  '/die-category-list': '555',
  '/die-subcategory': '555',
  '/die-size-list': '555',
  '/die-press-list': '555',
  '/die-type-list': '2',
  '/customer-type-list': '555',
    '/alloy-list': '555',
    '/temper-list': '555',
    '/store-list': '555',
    '/conversion-rate-list': '555',
    '/plant-type-list': '555',
    '/plant-list': '555',
    '/department-list': '555',
    '/item-category-list': '555',
  '/packing-mode-list': '555',
  '/vendor-list': '555',
  '/bolster-list': '555',
  '/nalco': '555',
  '/manage-user': '3',
  '/manage-user-group': '3',
  '/die-profilelist': '222',
  '/die-tool-list': '222',
  '/customer-list': '5',
  '/quotation-list': '5',
  '/die-quotation-list': '5',
  '/work-order-list': '5',
  '/proforma-list': '5',
  '/bulk-order-list': '5',
  '/work-order-date-wise': '16',
  '/packing-report-list': '16',
  '/packing-report': '16',
  '/dispatch-report': '16',
};
const items = [
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/add-dieprofile">Add Section/Profile</a>
      </>
    ),
    key: '0',
  },
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/add-new-customer">Add New Customer</a>
      </>
    ),
    key: '1',
  },
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/create-quotation">Create Quotation</a>
      </>
    ),
    key: '2',
  },
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/add-die-quotation">Create Die Quotation</a>
      </>
    ),
    key: '3',
  },
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/create-work-order">Create WorkOrder</a>
      </>
    ),
    key: '4',
  },
  {
    label: (
      <>
        <PlusOutlined style={{ marginRight: 8 }} />
        <a href="/create-proforma">Create Proforma</a>
      </>
    ),
    key: '5',
  },
];
export default function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: reduxUser } = useSelector(state => state.auth);
   const { data: settingData } = useSelector(state => state.setting);
  const [currentUser, setCurrentUser] = useState(reduxUser);
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const companyLogo = settingData?.company_settings?.company_logo || Logo;

  const [openKeys, setOpenKeys] = useState([]);

  const handleOpenChange = keys => {
    const latestOpenKey = keys.find(key => !openKeys.includes(key));
    if (latestOpenKey) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  const handleNavigate = event => {
    navigate(event.key);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    if (parentKeys[currentPath]) {
      setOpenKeys([parentKeys[currentPath]]);
    }
  }, [location.pathname]);
 
  const refreshUserData = () => {
    const localStorageKey = 'user';
    const userData = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    setCurrentUser(userData);
  };

  useEffect(() => {
    window.addEventListener('refreshUser', refreshUserData);
    return () => {
      window.removeEventListener('refreshUser', refreshUserData);
    };
  }, []);

  const showLogoutConfirm = () => {
    confirm({
      title: 'Are you sure you want to log out?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const keysToRemove = [
          'die_text_search_alloy',
          'die_group_search_alloy',
          'die_text_search_Bolster',
          'die_group_search_Bolster',
          'bundle_inward',
          'bundleInward_start_date',
          'bundleInward_end_date',
          'die_text_search_bundleOutWard',
          'die_group_search_bundleOutWard',
          'bundleOutward_start_date',
          'bundleOutward_end_date',
          'die_text_search_converstionRate',
          'die_group_search_converstionRate',
          'die_text_search_Party',
          'die_text_search_CurrentStock',
          'die_text_search_StockSummary',
          'customerList',
          'die_text_search_customerType',
          'die_group_search_customerType',
          'die_text_search_category',
          'die_text_search_die_group',
          'die_text_search_press',
          'die_group_search_press',
          'die_text_search_profile',
          'die_group_search',
          'die_text_search_size',
          'die_text_search_sub_category',
          'die_group_search_sub_category',
          'DieQuotationList',
          'die_text_search_tool',
          'die_group_search_tool',
          'die_text_search_BundlesSummary',
          'die_group_search_BundlesSummary',
          'die_text_search_Bundles',
          'die_group_search_Bundles',
          'ManageUser',
          'manageUserGroup',
          'nalcoList',
          'PlanningList',
          'PriorityList',
          'ProformaList',
          'quotationList',
          'addBundleUnVerification',
          'addBundleVerification',
          'editBundleUnVerification',
          'editBundleVerification',
          'stockVerificationList',
          'die_text_search_temper',
          'die_group_search_temper',
          'die_text_search_vendor',
          'die_group_search_vendor',
          'budleOutward_Warehouse',
          'bundleOutWard_Warehouse_start_date',
          'bundleOutWard_Warehouse_end_date',
          'die_text_search_Warehouse_Party',
          'die_text_search_Warehouse_CurrentStock',
          'die_text_search_Warehouse_StockSummary',
          'WorkOrderList_filter',
          'WorkOrderList',
        ];

        keysToRemove.forEach(key => localStorage.removeItem(key));
        localStorage.clear();
        dispatch(logoutAndReset());
      },
      onCancel() { },
    });
  };

  const inquiryPermissions = [
    // Inquiry
    'view_inquiry',
    'change_inquiry',
    'print_inquiry_pdf_copy',
    'delete_inquiry',
    'add_inquiry',
    'download_inquiry_pdf_copy',
    'download_inquiry_excel_copy'
  ];

  const inquiryQuotationPermissions = [

    // Inquiry Quotation
    'view_inquiryquotation',
    'change_inquiryquotation',
    'delete_inquiryquotation',
    'add_inquiryquotation',
    'download_inquiry_quotation_excel_copy',
    'download_inquiry_quotation_pdf_copy',
    'print_inquiry_quotation_pdf_copy',
  ];

  const inquirySalesOrderPermissions = [
    // Sales Orders
    'view_inquirysalesorder',
    'change_inquirysalesorder',
    'delete_inquirysalesorder',
    'add_inquirysalesorder',
    'download_inquiry_salesorder_excel_copy',
    'download_inquiry_salesorder_pdf_copy',
  ];

  const designDevPermissions = [
    'view_die',
    'change_die',
    'print_profile_pdf_copy',
    'delete_die',
    'view_dietool',
    'view_diegroup',
    'view_diecategory',
    'view_diesubcategory',
    'view_diesize',
    'view_diepress',
    'view_vendor',
    'view_blostermaster',
    'add_die',
    'download_profile_pdf_copy',
    'download_profile_excel_copy',
    'download_profile_tool_excel_copy',
    'download_profile_tool_pdf_copy',
    'download_profile_group_excel_copy',
    'download_profile_group_pdf_copy',
    'download_profile_category_excel_copy',
    'download_profile_category_pdf_copy',
    'download_profile_sub_category_excel_copy',
    'download_profile_sub_category_pdf_copy',
    'download_profile_size_excel_copy',
    'download_profile_size_pdf_copy',
    'download_profile_press_excel_copy',
    'download_profile_press_pdf_copy',
    'download_vendor_excel_copy',
    'download_vendor_pdf_copy',
    'download_bolster_excel_copy',
    'download_bolster_pdf_copy',
    'add_dietool',
    'delete_dietool',
    'change_dietool',
    'change_diegroup',
    'delete_diegroup',
    'add_diegroup',
    'change_diecategory',
    'delete_diecategory',
    'add_diecategory',
    'change_diesubcategory',
    'delete_diesubcategory',
    'add_diesubcategory',
    'change_diesize',
    'delete_diesize',
    'change_diepress',
    'delete_diepress',
    'change_vendor',
    'delete_vendor',
    'change_blostermaster',
    'delete_blostermaster',
  ];

  const customerPermissions = [
    // Direct customer actions
    'view_customer',
    'change_customer',
    'print_customer_workorder_report_pdf_copy',
    'delete_customer',
    'add_customer',
    'download_customer_pdf_copy',
    'download_customer_excel_copy',

    // Customer Type
    'view_customertype',
    'change_customertype',
    'delete_customertype',
    'add_customertype',
    'download_customer_type_excel_copy',
    'download_customer_type_pdf_copy',

    // Alloy
    'view_alloy',
    'change_alloy',
    'delete_alloy',
    'add_alloy',
    'download_alloy_excel_copy',
    'download_alloy_pdf_copy',

    // Temper
    'view_temper',
    'change_temper',
    'delete_temper',
    'add_temper',
    'download_temper_excel_copy',
    'download_temper_pdf_copy',

    // Conversion Rate
    'view_conversionrate',
    'change_conversionrate',
    'delete_conversionrate',
    'add_conversionrate',
    'download_conversion_rate_excel_copy',
    'download_conversion_rate_pdf_copy',

    // Plant Type
    'view_planttype',
    'change_planttype',
    'delete_planttype',
    'add_planttype',
  ];

  const quotationPermissions = [
    'print_quotation_pdf_copy',
    'change_quotation',
    'delete_quotation',
    'view_quotationdetail',
    'add_quotation',
    'view_nalcomaster',
    'change_nalcomaster',
    'delete_nalcomaster',
    'download_nalco_rate_excel_copy',
    'download_nalco_rate_pdf_copy',
    'add_nalcomaster',
  ];

  const DieQuotationPermission = [
    'delete_diequotation',
    'add_diequotation',
    'print_die_quotation_pdf_copy',
    'delete_diequotationdetails',
    'change_diequotation',
    'add_diequotationdetails',
    'view_diequotationdetails',
    'view_diequotation',
    'change_diequotationdetails',
  ];

  const workOrderPermission = ['add_workorder'];

  const proformaPermission = [
    'add_proformadetails',
    'change_proformadetails',
    'print_proforma_copy',
    'add_proforma',
    'change_proforma',
    'delete_proformadetails',
    'delete_proforma',
    'view_proformadetails',
    'view_proforma',
  ];

  const bundleInwardPermission = ['add_bundleinward'];

  const bundleOutwardPermission = ['add_bundleoutward'];

  const currentStockPermissions = [
    'print_current_stock_copy',
    'download_current_stock_excel_copy',
  ];

  const excessStockPermissions = [
    'add_excessstock',
    'delete_excessstock',
    'download_excess_stock_excel_copy',
    'print_excess_stock_copy',
    'change_excessstock',
    'view_excessstock',
  ];

  const stockVerificationPermissions = [
    'print_dispatch_verification_copy',
    'view_stockverification',
    'change_stockverification',
    'add_stockverification',
    'delete_stockverification',
    'print_stock_verification_copy',
  ];

  const DispatchVerificationPermissions = ['print_dispatch_verification_copy'];

  const productionPermission = [
    'change_production',
    'add_production',
    'delete_production',
    'view_production',
  ];

  const planningPermission = [
    'change_planning',
    'view_planning',
    'add_planning',
    'delete_planning',
    'download_planning_pdf_copy',
    'download_planning_priority_excel_copy',
    'download_planning_priority_pdf_copy',
    'download_planning_excel_copy',
  ];

  const warehouseBundleOutwardPermission = [
    'view_warehouse',
    'delete_warehouse',
    'add_warehouse',
    'print_warehouse_bundle_outward_copy',
    'change_warehouse',
    'download_warehouse_bundle_outward_excel_copy',
  ];

  const warehouseCurrentStockPermission = [
    'view_warehouse',
    'delete_warehouse',
    'add_warehouse',
    'change_warehouse',
    'print_warehouse_current_stock_copy',
    'download_warehouse_current_stock_excel_copy',
  ];

  const manageUserGroupPermissions = [
    'change_customgroup',
    'add_customgroup',
    'view_customgroup',
    'delete_customgroup'
  ];

  const manageUserPermissions = [
    'add_user',
    'change_user',
    'delete_user',
    'view_user',
    'change_userprofile',
    'delete_userprofile',
    'view_userprofile',
    'add_userprofile',
    'add_usergroupsmodel'
  ];

  const activityLogPermissions = ['view_logactivity'];

  const allPermissions = Object.values(
    currentUser?.permissions?.permissions ?? {}
  ).flat();

  const hasInquiryPermission = inquiryPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasInquiryQuotationPermission = inquiryQuotationPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasSalesOrderPermission = inquirySalesOrderPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasDesignDevPermission = designDevPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasCustomerPermission = customerPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasQuotationPermission = quotationPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasDieQuotationPermission = DieQuotationPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasWorkOrderPermission = workOrderPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasProformaPermission = proformaPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasBundleInwardPermission = bundleInwardPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasBundleOutwardPermission = bundleOutwardPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasCurrentStockPermissions = currentStockPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasExcessStockPermissions = excessStockPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasStockVerificationPermissions = stockVerificationPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasDispatchVerificationPermissions =
    DispatchVerificationPermissions.some(p => allPermissions.includes(p));

  const hasPlanningPermission = planningPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasproductionPermission = productionPermission.some(p =>
    allPermissions.includes(p),
  );

  const hasWarehouseBundleOutwardPermission =
    warehouseBundleOutwardPermission.some(p => allPermissions.includes(p));

  const hasWarehouseCurrentStockPermission =
    warehouseCurrentStockPermission.some(p => allPermissions.includes(p));

  const hasManageUserGroup = manageUserGroupPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasManageUser = manageUserPermissions.some(p =>
    allPermissions.includes(p),
  );

  const hasActivityLog = activityLogPermissions.some(p =>
    allPermissions.includes(p),
  );

  const userMenuItems = [
    {
      key: '1',
      label: <Link to="/profile">Profile</Link>,
    },
    {
      key: '4',
      label: <Link to="/change-password">Change Password</Link>,
    },
    {
      key: '3',
      label: <Link onClick={showLogoutConfirm}>Logout</Link>,
    },
  ];

  return (
    <section className="sidebar_menu_section">
      <Sider
        width={280}
        collapsible
        collapsed={collapsed}
        onBreakpoint={broken => broken}
        trigger={null}
        className="sidebar_menu_section"
        breakpoint="lg"
      >
        <div className="LogoSec">
          <img
            className="widhout-collapsed-logo"
            src={companyLogo}
            width={'181px'}
            height={'48px'}
            alt="logo"
          ></img>
          <img
            className="with-collapsed-logo"
            src={collapsed_logo}
            width={'30px'}
            alt="logo"
          ></img>
        </div>

        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[location.pathname]}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          onClick={event => {
            handleNavigate(event);
          }}
          style={{ padding: '12px' }}
          subMenuCloseDelay={0.01}
          triggerSubMenuAction={collapsed ? 'hover' : 'click'}
          items={[
            {
              key: '/dashboard',
              icon: (
                <span className="material-symbols-outlined">
                  bar_chart_4_bars
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Dashboard" placement="right">
                  <span>Dashboard</span>
                </Tooltip>
              ) : (
                <span>Dashboard</span>
              ),
            },
            {
              key: '555',
              icon: (
                <span className="material-symbols-outlined">
                  stacks
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Masters" placement="right">
                  <span>Masters</span>
                </Tooltip>
              ) : (
                <span>Masters</span>
              ),
              children: [
                {
                  key: '/customer-type-list',
                  label: collapsed ? (
                    <Tooltip title="Customer Types" placement="right">
                      <span>Customer Types</span>
                    </Tooltip>
                  ) : (
                    <span>Customer Types</span>
                  ),
                },
                {
                  key: '/alloy-list',
                  label: collapsed ? (
                    <Tooltip title="Alloys" placement="right">
                      <span>Alloys</span>
                    </Tooltip>
                  ) : (
                    <span>Alloys</span>
                  ),
                },
                {
                  key: '/temper-list',
                  label: collapsed ? (
                    <Tooltip title="Tempers" placement="right">
                      <span>Tempers</span>
                    </Tooltip>
                  ) : (
                    <span>Tempers</span>
                  ),
                },
               
                {
                  key: '/packing-mode-list',
                  label: collapsed ? (
                    <Tooltip title="Packing Mode" placement="right">
                      <span>Packing Mode</span>
                    </Tooltip>
                  ) : (
                    <span>Packing Mode</span>
                  ),
                },
                {
                  key: '/die-group-list',
                  label: collapsed ? (
                    <Tooltip title="Section Groups" placement="right">
                      <span>Section Groups</span>
                    </Tooltip>
                  ) : (
                    <span>Section Groups</span>
                  ),
                },
                {
                  key: '/die-category-list',
                  label: collapsed ? (
                    <Tooltip title="Section Categories" placement="right">
                      <span>Section Categories</span>
                    </Tooltip>
                  ) : (
                    <span>Section Categories</span>
                  ),
                },
                {
                  key: '/die-subcategory',
                  label: collapsed ? (
                    <Tooltip title="Section Sub Categories" placement="right">
                      <span>Section Sub Categories</span>
                    </Tooltip>
                  ) : (
                    <span>Section Sub Categories</span>
                  ),
                },
                {
                  key: '/die-size-list',
                  label: collapsed ? (
                    <Tooltip title="Section Size" placement="right">
                      <span>Section Size</span>
                    </Tooltip>
                  ) : (
                    <span>Section Size</span>
                  ),
                },
                {
                  key: '/die-press-list',
                  label: collapsed ? (
                    <Tooltip title="Press Master" placement="right">
                      <span>Section Press</span>
                    </Tooltip>
                  ) : (
                    <span>Section Press</span>
                  ),
                },
                {
                  key: '/vendor-list',
                  label: collapsed ? (
                    <Tooltip title="Vendors" placement="right">
                      <span>Vendors</span>
                    </Tooltip>
                  ) : (
                    <span>Vendors</span>
                  ),
                },
                {
                  key: '/bolster-list',
                  label: collapsed ? (
                    <Tooltip title="Bolster" placement="right">
                      <span>Bolster</span>
                    </Tooltip>
                  ) : (
                    <span>Bolster</span>
                  ),
                },
                {
                  key: '/nalco',
                  label: collapsed ? (
                    <Tooltip title="Nalco Rate" placement="right">
                      <span>Nalco Rate</span>
                    </Tooltip>
                  ) : (
                    <span>Nalco Rate</span>
                  ),
                },
                {
                  key: '/store-list',
                  label: collapsed ? (
                    <Tooltip title="Stores" placement="right">
                      <span>Stores</span>
                    </Tooltip>
                  ) : (
                    <span>Stores</span>
                  ),
                },
                {
                  key: '/conversion-rate-list',
                  label: collapsed ? (
                    <Tooltip title="Conversion Rate" placement="right">
                      <span>Conversion Rate</span>
                    </Tooltip>
                  ) : (
                    <span>Conversion Rate</span>
                  ),
                },
                {
                  key: '/plant-type-list',
                  label: collapsed ? (
                    <Tooltip title="Plant Type Master" placement="right">
                      <span>Plant Type</span>
                    </Tooltip>
                  ) : (
                    <span>Plant Type</span>
                  ),
                },
                {
                  key: '/plant-list',
                  label: collapsed ? (
                    <Tooltip title="Plant Master" placement="right">
                      <span>Plant</span>
                    </Tooltip>
                  ) : (
                    <span>Plant</span>
                  ),
                },
                {
                  key: '/department-list',
                  label: collapsed ? (
                    <Tooltip title="Department Master" placement="right">
                      <span>Department</span>
                    </Tooltip>
                  ) : (
                    <span>Department</span>
                  ),
                },
                {
                  key: '/item-category-list',
                  label: collapsed ? (
                    <Tooltip title="Item Category Master" placement="right">
                      <span>Item Category</span>
                    </Tooltip>
                  ) : (
                    <span>Item Category</span>
                  ),
                },
              ]
            },
            (hasInquiryPermission ||
              hasInquiryQuotationPermission ||
              hasSalesOrderPermission) && {
              key: '6',
              icon: (
                <span className="material-symbols-outlined">
                  webhook
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="CRM" placement="right">
                  <span>CRM</span>
                </Tooltip>
              ) : (
                <span>CRM</span>
              ),
              children: [
                hasInquiryPermission && {
                  key: '/inquiry-list',
                  label: collapsed ? (
                    <Tooltip title="Inquiry" placement="right">
                      <span>Inquiry</span>
                    </Tooltip>
                  ) : (
                    <span>Inquiry</span>
                  ),
                },
                hasInquiryQuotationPermission && {
                  key: '/inquiry-quotation-list',
                  label: collapsed ? (
                    <Tooltip title="Inquiry Quotation" placement="right">
                      <span>Quotation</span>
                    </Tooltip>
                  ) : (
                    <span>Quotation</span>
                  ),
                },
                hasSalesOrderPermission && {
                  key: '/sales-order-list',
                  label: collapsed ? (
                    <Tooltip title="Sales Order" placement="right">
                      <span>Sales Orders</span>
                    </Tooltip>
                  ) : (
                    <span>Sales Orders</span>
                  ),
                },
              ].filter(Boolean),
            },
            hasDesignDevPermission && {
              key: '222',
              icon: (
                <span className="material-symbols-outlined">
                  design_services
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Design & Development" placement="right">
                  <span>Design & Development</span>
                </Tooltip>
              ) : (
                <span>Design & Development</span>
              ),
              children: [
                hasInquiryPermission && {
                  key: '/die-profilelist',
                  label: collapsed ? (
                    <Tooltip title="Section" placement="right">
                      <span>Section</span>
                    </Tooltip>
                  ) : (
                    <span>Section</span>
                  ),
                },
                hasInquiryQuotationPermission && {
                  key: '/die-tool',
                  label: collapsed ? (
                    <Tooltip title="Die Tool" placement="right">
                      <span>Die Tool</span>
                    </Tooltip>
                  ) : (
                    <span>Die Tool</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasCustomerPermission ||
              hasQuotationPermission ||
              hasDieQuotationPermission ||
              hasWorkOrderPermission ||
              hasProformaPermission) && {
              key: '5',
              icon: (
                <span className="material-symbols-outlined">
                  trending_up
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Sales & Management" placement="right">
                  <span>Sales & Management</span>
                </Tooltip>
              ) : (
                <span>Sales & Management</span>
              ),
              children: [
                hasCustomerPermission && {
                  key: '/customer-list',
                  label: collapsed ? (
                    <Tooltip title="Customer" placement="right">
                      <span>Customer</span>
                    </Tooltip>
                  ) : (
                    <span>Customer</span>
                  ),
                },
                hasQuotationPermission && {
                  key: '/quotation-list',
                  label: collapsed ? (
                    <Tooltip title="Quotation" placement="right">
                      <span>Quotation</span>
                    </Tooltip>
                  ) : (
                    <span>Quotation</span>
                  ),
                },
                hasDieQuotationPermission && {
                  key: '/die-quotation-list',
                  label: collapsed ? (
                    <Tooltip title="Die Quotation" placement="right">
                      <span>Die Quotation</span>
                    </Tooltip>
                  ) : (
                    <span>Die Quotation</span>
                  ),
                },
                hasWorkOrderPermission && {
                  key: '/work-order-list',
                  label: collapsed ? (
                    <Tooltip title="Work Orders" placement="right">
                      <span>Work Orders</span>
                    </Tooltip>
                  ) : (
                    <span>Work Orders</span>
                  ),
                },
                hasProformaPermission && {
                  key: '/proforma-list',
                  label: collapsed ? (
                    <Tooltip title="Proforma's" placement="right">
                      <span>Proforma's</span>
                    </Tooltip>
                  ) : (
                    <span>Proforma's</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasPlanningPermission || hasproductionPermission) && {
              key: '15',
              icon: (
                <span className="material-symbols-outlined">
                  precision_manufacturing
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Production" placement="right">
                  <span>Production</span>
                </Tooltip>
              ) : (
                <span>Production</span>
              ),
              children: [
                hasPlanningPermission && {
                  key: '/planning-list',
                  label: collapsed ? (
                    <Tooltip title="Planning" placement="right">
                      <span>Planning</span>
                    </Tooltip>
                  ) : (
                    <span>Planning</span>
                  ),
                },
                hasproductionPermission && {
                  key: '/production-list',
                  label: collapsed ? (
                    <Tooltip title="Production" placement="right">
                      <span>Production</span>
                    </Tooltip>
                  ) : (
                    <span>Production</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasBundleInwardPermission ||
              hasBundleOutwardPermission ||
              hasCurrentStockPermissions ||
              hasExcessStockPermissions ||
              hasStockVerificationPermissions ||
              hasDispatchVerificationPermissions) && {
              key: '14',
              icon: (
                <span className="material-symbols-outlined">
                  pallet
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Packing & Dispatch" placement="right">
                  <span>Packing & Dispatch</span>
                </Tooltip>
              ) : (
                <span>Packing & Dispatch</span>
              ),
              children: [
                hasBundleInwardPermission && {
                  key: '/bundle-inward',
                  label: collapsed ? (
                    <Tooltip title="Bundle Inward" placement="right">
                      <span>Bundle Inward</span>
                    </Tooltip>
                  ) : (
                    <span>Bundle Inward</span>
                  ),
                },
                hasBundleOutwardPermission && {
                  key: '/bundle-outward',
                  label: collapsed ? (
                    <Tooltip title="Bundle Outward" placement="right">
                      <span>Bundle Outward</span>
                    </Tooltip>
                  ) : (
                    <span>Bundle Outward</span>
                  ),
                },
                hasCurrentStockPermissions && {
                  key: '/current-stock-data',
                  label: collapsed ? (
                    <Tooltip title="Current Stock" placement="right">
                      <span>Current Stock</span>
                    </Tooltip>
                  ) : (
                    <span>Current Stock</span>
                  ),
                },
                hasExcessStockPermissions && {
                  key: '/excess-stock',
                  label: collapsed ? (
                    <Tooltip title="Excess Stock" placement="right">
                      <span>Excess Stock</span>
                    </Tooltip>
                  ) : (
                    <span>Excess Stock</span>
                  ),
                },
                hasStockVerificationPermissions && {
                  key: '/stock-verification',
                  label: collapsed ? (
                    <Tooltip title="Stock Verification" placement="right">
                      <span>Stock Verification</span>
                    </Tooltip>
                  ) : (
                    <span>Stock Verification</span>
                  ),
                },
                hasDispatchVerificationPermissions && {
                  key: '/dispatch-verification',
                  label: collapsed ? (
                    <Tooltip title="Dispatch Verification" placement="right">
                      <span>Dispatch Verification</span>
                    </Tooltip>
                  ) : (
                    <span>Dispatch Verification</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasWorkOrderPermission ||
              hasBundleInwardPermission ||
              hasBundleOutwardPermission) && {
              key: '16',
              icon: (
                <span className="material-symbols-outlined">
                  lab_profile
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Reports" placement="right">
                  <span>Reports</span>
                </Tooltip>
              ) : (
                <span>Reports</span>
              ),
              children: [
                hasWorkOrderPermission && {
                  key: '/work-order-date-wise',
                  label: collapsed ? (
                    <Tooltip title="Work Order Report" placement="right">
                      <span>Work Order</span>
                    </Tooltip>
                  ) : (
                    <span>Work Order</span>
                  ),
                },
                hasBundleInwardPermission && {
                  key: '/packing-report-list',
                  label: collapsed ? (
                    <Tooltip title="Packing Report" placement="right">
                      <span>Packing Report</span>
                    </Tooltip>
                  ) : (
                    <span>Packing Report</span>
                  ),
                },
                hasBundleInwardPermission && {
                  key: '/packing-report',
                  label: collapsed ? (
                    <Tooltip title="Packing Datewise Report" placement="right">
                      <span>Packing Datewise Report</span>
                    </Tooltip>
                  ) : (
                    <span>Packing Datewise Report</span>
                  ),
                },
                hasBundleOutwardPermission && {
                  key: '/dispatch-report',
                  label: collapsed ? (
                    <Tooltip title="Dispatch Report" placement="right">
                      <span>Dispatch Report</span>
                    </Tooltip>
                  ) : (
                    <span>Dispatch Report</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasWarehouseBundleOutwardPermission ||
              hasWarehouseCurrentStockPermission) && {
              key: '223',
              icon: (
                <span className="material-symbols-outlined">
                  shelves
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Warehouse" placement="right">
                  <span>Warehouse</span>
                </Tooltip>
              ) : (
                <span>Warehouse</span>
              ),
              children: [
                hasWarehouseBundleOutwardPermission && {
                  key: '/warehouse-bundle-outward',
                  label: collapsed ? (
                    <Tooltip title="Bundle OutWard" placement="right">
                      <span>Bundle OutWard</span>
                    </Tooltip>
                  ) : (
                    <span>Bundle OutWard</span>
                  ),
                },
                hasWarehouseCurrentStockPermission && {
                  key: '/warehouse-current-stock',
                  label: collapsed ? (
                    <Tooltip title="Current Stock" placement="right">
                      <span>Current Stock</span>
                    </Tooltip>
                  ) : (
                    <span>Current Stock</span>
                  ),
                },
              ].filter(Boolean),
            },
            (hasWarehouseBundleOutwardPermission ||
              hasWarehouseCurrentStockPermission) && {
              key: '224',
              icon: (
                <span className="material-symbols-outlined">
                  local_shipping
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Logistics" placement="right">
                  <span>Logistics</span>
                </Tooltip>
              ) : (
                <span>Logistics</span>
              ),
              children: [
                hasWarehouseBundleOutwardPermission && {
                  key: '/transporter-list',
                  label: collapsed ? (
                    <Tooltip title="Transporter" placement="right">
                      <span>Transporter</span>
                    </Tooltip>
                  ) : (
                    <span>Transporter</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/vehicle-type-list',
                  label: collapsed ? (
                    <Tooltip title="Vehicle Type" placement="right">
                      <span>Vehicle Type</span>
                    </Tooltip>
                  ) : (
                    <span>Vehicle Type</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/vehicle-list',
                  label: collapsed ? (
                    <Tooltip title="Vehicle Master" placement="right">
                      <span>Vehicle Master</span>
                    </Tooltip>
                  ) : (
                    <span>Vehicle Master</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/material-list',
                  label: collapsed ? (
                    <Tooltip title="Material Master" placement="right">
                      <span>Material Master</span>
                    </Tooltip>
                  ) : (
                    <span>Material Master</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/first-weight-entry-list',
                  label: collapsed ? (
                    <Tooltip title="First Weight Entry Master" placement="right">
                      <span>First Weight Entry Master</span>
                    </Tooltip>
                  ) : (
                    <span>First Weight Entry Master</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/second-weight-entry-list',
                  label: collapsed ? (
                    <Tooltip title="Second Weight Entry Master" placement="right">
                      <span>Second Weight Entry Master</span>
                    </Tooltip>
                  ) : (
                    <span>Second Weight Entry Master</span>
                  ),
                },
                hasWarehouseBundleOutwardPermission && {
                  key: '/manual-weight-entry-list',
                  label: collapsed ? (
                    <Tooltip title="Manual Weight Entry Master" placement="right">
                      <span>Manual Weight Entry Master</span>
                    </Tooltip>
                  ) : (
                    <span>Manual Weight Entry Master</span>
                  ),
                }
              ].filter(Boolean),
            },
            (hasManageUserGroup || hasManageUser || hasActivityLog) && {
              key: '3',
              icon: (
                <span className="material-symbols-outlined">
                  settings_account_box
                </span>
              ),
              label: collapsed ? (
                <Tooltip title="Manage User" placement="right">
                  <span>Manage User</span>
                </Tooltip>
              ) : (
                <span>Manage User</span>
              ),
              children: [
                hasManageUserGroup && {
                  key: '/manage-user-group',
                  label: collapsed ? (
                    <Tooltip title="Manage User Group" placement="right">
                      <span>Manage User Group</span>
                    </Tooltip>
                  ) : (
                    <span>Manage User Group</span>
                  ),
                },
                hasManageUser && {
                  key: '/manage-user',
                  label: collapsed ? (
                    <Tooltip title="Manage User" placement="right">
                      <span>Manage User</span>
                    </Tooltip>
                  ) : (
                    <span>Manage User</span>
                  ),
                },
                hasActivityLog && {
                  key: '/activity-log-list',
                  label: collapsed ? (
                    <Tooltip title="Activities" placement="right">
                      <span>Activity Log</span>
                    </Tooltip>
                  ) : (
                    <span>Activity Log</span>
                  ),
                },
              ].filter(Boolean),
            },
            {
              key: '/setting',
              icon: (
                <span className="material-symbols-outlined">
                  settings
                </span>
              ),
              label: (
                <Tooltip title="Dashboard" placement="right">
                  <span>
                    Settings
                  </span>
                </Tooltip>
              ),
            },
          ].filter(Boolean)}
        />
        <div className="sidebaraction">
          <div className="inraction">
            <Dropdown
              className="addmenu"
              menu={{
                items,
              }}
              trigger={['click']}
              placement="bottomRight"
            >
              <Link>
                <PlusOutlined /> <span className="txt">Quick Add</span>
              </Link>
            </Dropdown>
            <Dropdown
              menu={{ items: userMenuItems }}
              trigger={['click']}
              className="usermenu"
            >
              <div
                style={{
                  gap: '5px',
                }}
              >
                {currentUser && (
                  <Avatar
                    className="ant-avatar"
                    src={
                      currentUser.profile_image === ''
                        ? profilePic
                        : currentUser.profile_image
                    }
                  />
                )}
                {currentUser && (
                  <span className="usrnm">
                    {currentUser.first_name} {currentUser.last_name}
                  </span>
                )}
                <DownOutlined />
              </div>
            </Dropdown>

            <Button type="link" className="btnicon" onClick={showLogoutConfirm}>
              <LogoutOutlined />
              <span className="txt"> Logout</span>
            </Button>
          </div>
        </div>
      </Sider>
      <Button
        type="text"
        className="toggleBtn"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 64,
        }}
      />
    </section>
  );
}
